import { render, staticRenderFns } from "./UtilsTab.vue?vue&type=template&id=0da8863a&scoped=true&"
import script from "./UtilsTab.vue?vue&type=script&lang=js&"
export * from "./UtilsTab.vue?vue&type=script&lang=js&"
import style0 from "./UtilsTab.vue?vue&type=style&index=0&id=0da8863a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da8863a",
  null
  
)

export default component.exports